import { VenueForm } from "components/venues";
import { useQueryVenue } from "hooks/venues";
import { useParams } from "react-router-dom";

export const EditVenue = () => {
  const { uid } = useParams();

  const { isLoading, isError, error, venue } = useQueryVenue({
    uid: uid!,
  });

  if (isLoading) {
    return null;
  }
  if (isError) {
    return (
      <div>
        Something went wrong:
        {error?.message}
      </div>
    );
  }

  return <VenueForm venue={venue} />;
};
